"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.PanelNavigatorContext = exports.defaultPanelNavigatorContext = void 0;

var _react = _interopRequireDefault(require("react"));

var defaultPanelNavigatorContext = {};
exports.defaultPanelNavigatorContext = defaultPanelNavigatorContext;

var PanelNavigatorContext = _react.default.createContext(defaultPanelNavigatorContext);

exports.PanelNavigatorContext = PanelNavigatorContext;
var Consumer = PanelNavigatorContext.Consumer,
    Provider = PanelNavigatorContext.Provider;
exports.Provider = Provider;
exports.Consumer = Consumer;